import { useQuery } from 'react-query';
import { lovageApi } from 'src/axios';

export interface Voicemail {
  id: number;
  location_name: string;
  transcript: string;
  duration: number;
  from_formatted: string;
  created_on: string; // date
}

export interface ExpandedVoicemail extends Voicemail {
  voicemail_link: string;
}

export const fetchVoicemail = (voicemailId: number) =>
  lovageApi.get<ExpandedVoicemail>(`/dashboard/voicemail/${voicemailId}`).then((res) => res.data);

export default function useVoicemail(voicemailId: number, { enabled = true } = {}) {
  return useQuery(['voicemail', voicemailId], () => fetchVoicemail(voicemailId), {
    enabled,
  });
}
